import React from 'react';
import Context from '../Container/Context';

export default ({ to, children, onChange, ...rest }) => {
  const { history } = React.useContext(Context);
  const handlePush = (e) => {
    e.preventDefault();
    history.push(to);
    onChange && onChange(to);
  };

  return (
    <a {...rest} href="/" onClick={handlePush}>
      {children}
    </a>
  );
};
